<template>
    <div class="w3-row w3-padding issue" style="border-bottom: 1px solid #f8f9fb">
        <router-link
          :to="{ name: 'issuedetail', params: {slug: workspace.slug, issueslug:issue.slug} }"
        >
          <div class="w3-col l9 m9 s9 w3-small w3-bluex">
            <label class="w3-padding-small tag" v-html="ws_priority_tag_icon[issue.priority-1]"></label>
            <label class="w3-padding-small tag">
              <b>{{ issue_number(issue.id) }}</b>
            </label>
            <label class="pad-2" v-html="ws_status_tag_icon[issue.status-1]"></label>
            <label>
              {{ issue.name }}
            </label>
          </div>
        </router-link>

      <div class="w3-col l3 m3 s3 w3-right-align w3-small w3-dred">
        <div class="w3-row">

          <!-- <div class="w3-col l8 m8 s8 over-flow w3-right-align w3-green"> -->
            <label v-if="issue.project_id" class="project-tab">
              <i class="fa fa-border-all" style="color: #bdbdbd;"></i>
              <label class="over-flowx"> {{ project(issue.project_id, 'name') }}</label>
            </label>
          <!-- </div> -->

          <!-- <div class="w3-col l4 m4 s4 w3-right w3-yellow"> -->
            <label class="w3-padding-small">
              {{moment(issue.created_on).format('MMM D')}}
            </label>

            <label class="tag w3-padding-small">
              <i class="fa fa-user-circle"></i>
            </label>
          <!-- </div> -->
        </div>

      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import router from '@/router'

export default {
  name: 'IssueTemplate',

  props: {
    issue: Object,
  },

  methods: {
    status: function (value) {
      const res = this.ws_project_status.find( ({ id }) => id === value )
      return res.title
    },

    project: function(value, property){
      if (value && this.ws_projects.length > 0) {
        const result = this.ws_projects.find( ({ id }) => id === value )[property];
        if (result.length > 8) {
          return result.slice(0,8)+"..."
        } return result
      }
      return "";
    },

    issue_number: function (id) {
      const res = this.issues.slice().reverse().findIndex(x=> x.id === id)
      return '#'+ (res+1)
    }
  },

  mounted: function () {

  },

  computed: {
    ...mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
    ...mapGetters('workspace', ['ws_issues', 'ws_projects', 'ws_status_tag', 'ws_status_tag_icon', 'ws_priority_tag_icon']),
    ...mapState('workspace', ['issues']),

    workspace: function(){
      const result = this.workspaces.find( ({ slug }) => slug === this.$route.params.slug );
      return result;
    },



  }

}

</script>

<style scoped>
.block{
  display: inline-block;
}

.tag{
  /* margin: 0 3px 0 3px; */
  width: 35px;
  text-align: center;
  display: inline-block;
}

.tag-2{
  /* width:  */
}

.pad-2{
  padding: 2px 2px;
}

.issue:hover{
  border-left: 2px solid #5d6ad2;
}

.project-tab{
  border: 1px solid #ccc;
  border-radius: 4px;
  display:inline-block;
  padding-left:8px;
  padding-right:8px;
  text-align:center;
}
</style>
